export default __webpack_public_path__ + "static/media/versatility-solution.3a0cf3f5.png";